export class DateHelper {
  private static _months = [
    null,
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December",
  ];

  static getMonthString(month: number): string {
    return this._months[month] || "";
  }
}
